/**
 * PrintingPreferenceToggle - Radio group for edition preference during import
 *
 * Allows users to choose between using exact printings from import data
 * or matching to printings they already own in their collection.
 */
import type { ReactElement } from 'react';

import { FaLayerGroup, FaThumbtack } from 'react-icons/fa';

import type { PrintingPreference } from '../lib/formatAdapters';

export interface PrintingPreferenceToggleProps {
  value: PrintingPreference;
  onChange: (value: PrintingPreference) => void;
}

export default function PrintingPreferenceToggle({ value, onChange }: PrintingPreferenceToggleProps): ReactElement {
  return (
    <div>
      <h4 className="text-pearl mb-2 text-sm font-medium">Printing Preference</h4>
      <div className="space-y-1.5">
        <label className="flex cursor-pointer items-start gap-2 rounded-lg p-1.5 select-none hover:bg-white/5">
          <input
            type="radio"
            name="printing-preference"
            value="exact"
            checked={value === 'exact'}
            onChange={() => onChange('exact')}
            className="text-aether focus:ring-aether mt-0.5"
          />
          <div className="flex items-center gap-1.5">
            <FaThumbtack className="text-ash h-3 w-3 shrink-0" />
            <span className="text-silver text-sm">Use exact printings</span>
          </div>
        </label>
        <label className="flex cursor-pointer items-start gap-2 rounded-lg p-1.5 select-none hover:bg-white/5">
          <input
            type="radio"
            name="printing-preference"
            value="collection"
            checked={value === 'collection'}
            onChange={() => onChange('collection')}
            className="text-aether focus:ring-aether mt-0.5"
          />
          <div className="flex items-center gap-1.5">
            <FaLayerGroup className="text-ash h-3 w-3 shrink-0" />
            <span className="text-silver text-sm">Match to my collection</span>
          </div>
        </label>
      </div>
    </div>
  );
}
